// @flow
import Resource from 'speed-js-core/src/api/Resource';

export default class DeviceUnlockResource extends Resource {
    basePath: string = 'devices/unlock/';

    objectPath: string = 'devices/unlock/{ident}/';
}
